/** The Hub — private agent/broker BBS. Isolated from client messaging and Journey community. */

export const THEHUB_PREFIX = "dh_thehub_";
export const THEHUB_EVENT = "dh-thehub-change";
export const THEHUB_POLL_MS = 3000;
/** Upcoming listings window — past dates drop on refresh; nothing beyond this horizon is kept. */
export const HUB_LISTING_HORIZON_DAYS = 60;
export const HUB_HALL = "hall";

export const HUB_CATEGORIES = [
  {
    id: "chat",
    label: "Broker / Agent Chat",
    kind: "chat",
    blurb: "A quiet lounge for desk notes between brokers and agents. Client files stay outside this door.",
    initials: "BA",
    tone: { wash: "#e8eee9", ink: "#2c3a32", accent: "#4a6741" },
  },
  {
    id: "associations",
    label: "Broker / Agent Associations",
    kind: "groups",
    blurb: "Office circles — each brokerage may open a room of its own for chat, listings, and announcements.",
    initials: "AS",
    tone: { wash: "#eee8df", ink: "#3a3228", accent: "#7a6144" },
  },
  {
    id: "city",
    label: "City-Level Rooms",
    kind: "geo",
    blurb: "City cadence: mixers, board breakfasts, and who is covering which neighborhood this month.",
    initials: "CY",
    tone: { wash: "#e7eef3", ink: "#243038", accent: "#3d5c6e" },
  },
  {
    id: "county",
    label: "County-Level Rooms",
    kind: "geo",
    blurb: "County forums and civic listings held as a convenience for members.",
    initials: "CO",
    tone: { wash: "#ebe8f2", ink: "#2e2a38", accent: "#5a4d73" },
  },
  {
    id: "state",
    label: "State-Level Rooms",
    kind: "geo",
    blurb: "State association gatherings and education weeks. Confirm hours with the host before you travel.",
    initials: "ST",
    tone: { wash: "#e9f0ea", ink: "#243028", accent: "#3f6b4e" },
  },
  {
    id: "national",
    label: "National-Level Rooms",
    kind: "geo",
    blurb: "National weeks, leadership, and association calendars — a wide hall, still unhurried.",
    initials: "NA",
    tone: { wash: "#f0ebe4", ink: "#352c24", accent: "#8a5a3a" },
  },
  {
    id: "chambers",
    label: "Chambers & Business Groups",
    kind: "geo",
    blurb: "Chambers, councils, and business breakfasts. Guests welcome with a member.",
    initials: "CH",
    tone: { wash: "#f3efe4", ink: "#383228", accent: "#8b7344" },
  },
  {
    id: "gatherings",
    label: "Major Gatherings",
    kind: "geo",
    blurb: "Conventions, summits, expos, and conference hotels. Not a REChecklist-hosted event.",
    initials: "MG",
    tone: { wash: "#e8eef0", ink: "#273236", accent: "#4a6a72" },
  },
  {
    id: "special",
    label: "Special Events (Admin-Posted)",
    kind: "special",
    blurb: "A small salon for program-posted events only. Featured pieces sit at the front.",
    initials: "SE",
    tone: { wash: "#f4e8e8", ink: "#3a2828", accent: "#7a4545" },
  },
];

export const EVENT_TYPES = [
  { id: "city", label: "City-level event" },
  { id: "county", label: "County-level event" },
  { id: "state", label: "State-level event" },
  { id: "national", label: "National-level event" },
  { id: "chamber", label: "Chamber" },
  { id: "gathering", label: "Major gathering" },
  { id: "convention", label: "Convention" },
  { id: "summit", label: "Summit" },
  { id: "expo", label: "Expo" },
  { id: "other", label: "Other" },
];

export const REQUEST_STATUSES = [
  { id: "pending", label: "Pending review" },
  { id: "approved", label: "Approved" },
  { id: "declined", label: "Declined" },
];

export function categoryMeta(id) {
  return HUB_CATEGORIES.find((item) => item.id === id) || null;
}

export function categoryLabel(id) {
  return categoryMeta(id)?.label || id || "";
}

export function eventTypeLabel(id) {
  return EVENT_TYPES.find((item) => item.id === id)?.label || id || "";
}

export function eventCategoryForType(type) {
  if (type === "chamber") return "chambers";
  if (["gathering", "convention", "summit", "expo"].includes(type)) return "gatherings";
  if (["city", "county", "state", "national"].includes(type)) return type;
  return "gatherings";
}

export function canUseTheHub(session) {
  const role = session?.role;
  return role === "agent" || role === "broker" || role === "admin";
}

export function isHubHall(id) {
  return !id || id === HUB_HALL;
}
